module.exports = __webpack_public_path__ + "static/media/profile.8a8e05b3.svg";